'use client';

import { useContext } from 'react';
import { AuthContext } from '@/contexts/AuthContext';
import UserSignIn from '../UserSignin';
import UserCreateAccount from '../UserCreateAccount';
import UserConfirmAccount from '../UserConfirmAccount';
import UserConfirmationSuccessfully from '../UserConfirmationSuccessfully';
import UserResetPassword from '../UserResetPassword';

const UserMenuTabs = () => {
  const { menuStatus, handleChangeStatus } = useContext(AuthContext);

  if (menuStatus === 'signin') {
    return <UserSignIn />;
  }

  if (menuStatus === 'recover_account') {
    return <UserResetPassword />;
  }

  if (menuStatus === 'new_account') {
    return <UserCreateAccount />;
  }

  if (menuStatus === 'confirm_account') {
    return (
      <UserConfirmAccount
        successAction={() => handleChangeStatus('account_successfully')}
      />
    );
  }

  if (menuStatus === 'account_successfully') {
    return <UserConfirmationSuccessfully />;
  }

  return null;
};

export default UserMenuTabs;
